<template>
  <div
    class="form-group"
    :class="{
      '-large': large,
    }"
  >
    <div class="header">
      {{ label }}
    </div>
    <slot />
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: '',
  },
  large: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group.-large {
  gap: 24px;
  & .header {
    font-size: var(--font-size-300);
    line-height: var(--line-height-headings);
    font-weight: 700;
    color: var(--blue);
  }
}
</style>
